/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'resource': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M1023.85 341.333h-85.333V170.667H383.851V85.333h640z"/><path pid="1" d="M327.573 85.333L433.43 332.267 455.573 384h483.094v554.667H85.333V85.333h242.39M384 0H0v1024h1024V298.667H512z"/><path pid="2" d="M511.83 725.333h298.88v85.334H511.83z"/>'
  }
})
